import attendance from '~/packages/publicHealth/datasets/attendance'
import attendanceOccurrence from '~/packages/publicHealth/datasets/attendanceOccurrence'
import citizenHealthProfile from '~/packages/publicHealth/datasets/citizenHealthProfile'
import citizen from '~/packages/publicHealth/datasets/citizen'
import { NativeBaseOptional } from '~/prix/types/type'
import family from '~/packages/publicHealth/datasets/family'
import residenceProfile from '~/packages/publicHealth/datasets/residenceProfile'
import healthProfessional from '~/packages/publicHealth/datasets/healthProfessional'
import medicalProcedureRequested from '~/packages/publicHealth/datasets/medicalProcedureRequested'
import healthUnit from '~/packages/publicHealth/datasets/healthUnit'
import healthTeam from '~/packages/publicHealth/datasets/healthTeam'
import vaccineAdministration from '~/packages/publicHealth/datasets/vaccineAdministration'
import healthcareReferral from '~/packages/publicHealth/datasets/healthcareReferral'
import medicalCertificate from '~/packages/publicHealth/datasets/medicalCertificate'
import { isDevelopment } from '~/utils/shared/platform'
import homeVisit from '~/packages/publicHealth/datasets/homeVisit'
import prescribedDrugs from '~/packages/publicHealth/datasets/prescribedDrugs'
import dentalAttendance from '~/packages/publicHealth/datasets/dentalAttendance'
import dentalClinicalEvolution from '~/packages/publicHealth/datasets/dentalClinicalEvolution'
import activity from '~/packages/publicHealth/datasets/activity'
import attendanceMedicalProcedure from '~/packages/publicHealth/datasets/attendanceMedicalProcedure'

export const bucketName = isDevelopment
  ? 'prix--gov-development-datasets'
  : 'prix-gov-production-dataset-files'
export const pattern = /^(\d+)\/([^/]+)\.csv$/

export interface Dataset {
  schema: string
  table: string
  columnTransformMap: Record<string, (original: NativeBaseOptional) => NativeBaseOptional>
}

export const datasets: Record<string, Dataset> = {
  citizen,
  attendance,
  'attendance-occurrence': attendanceOccurrence,
  'citizen-health-profile': citizenHealthProfile,
  family,
  'residence-profile': residenceProfile,
  'health-professional': healthProfessional,
  'health-unit': healthUnit,
  'health-team': healthTeam,
  'medical-procedure-requested': medicalProcedureRequested,
  'home-visit': homeVisit,
  'prescribed-drugs': prescribedDrugs,
  'vaccine-administration': vaccineAdministration,
  'healthcare-referral': healthcareReferral,
  'medical-certificate': medicalCertificate,
  'dental-attendance': dentalAttendance,
  'dental-clinical-evolution': dentalClinicalEvolution,
  activity,
  'attendance-medical-procedure': attendanceMedicalProcedure,
}
